/**
 * Field labels for the invoice form's validated paths. Array indices are
 * dropped before lookup, so one entry covers every row of a list.
 */
const FIELD_LABELS: Record<string, string> = {
  "payer.payerId": "Client",
  "payer.payerEngagementId": "Assignment",
  "payer.emailsCC.email": "Client CC emails",
  lineItems: "Work items",
  purchaseOrderNumber: "PO number",
  due: "Payment terms",
  customDueDate: "Custom due date",
  "other.projectName": "Project name",
  "other.attachments": "Attachments",
  "lateFee.amount": "Late fee amount",
  "lateFee.type": "Late fee type",
  "lateFee.every": "Late fee frequency",
  "lateFee.interval": "Late fee frequency",
  "send.type": "Send",
  "send.date": "Send date",
  "frequency.every": "Repeat every",
  "frequency.interval": "Repeat every",
  "frequency.end": "End series",
  "frequency.endDate": "End date",
  "frequency.endAfter": "Number of occurrences"
};

const isArrayIndex = (key: string) => /^\d+$/.test(key);

const humanizePath = (path: string) => {
  const name = path.split(".").pop() ?? path;
  const words = name
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .trim();

  return words.charAt(0).toUpperCase() + words.slice(1);
};

const collectPaths = (node: unknown, path: string, paths: string[]) => {
  if (!node || typeof node !== "object") {
    return;
  }

  const candidate = node as { message?: unknown; type?: unknown };
  if (
    typeof candidate.message === "string" ||
    typeof candidate.type === "string"
  ) {
    paths.push(path);
    return;
  }

  Object.entries(node).forEach(([key, child]) => {
    const childPath = isArrayIndex(key) ? path : path ? `${path}.${key}` : key;

    collectPaths(child, childPath, paths);
  });
};

/**
 * The human labels of the fields a react-hook-form error tree holds, for the
 * form-level summary the invoice form shows when a submit is blocked.
 */
export const selectorInvoiceFormErrorLabels = (errors: unknown): string[] => {
  const paths: string[] = [];
  collectPaths(errors, "", paths);

  return Array.from(
    new Set(paths.map(path => FIELD_LABELS[path] ?? humanizePath(path)))
  );
};
